export const notificationsSelector = ({ notifications: { items } }) => items;
